<i
    [pTooltip]="tooltip"
    [ngClass]="icon + ' ' + (spin ? 'pi-spin' : '')"
    [ngStyle]="style"
></i>
